import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import icon from 'scoreboard/components/icon'
import template from './view-icons.hbs'

let ViewIconsView = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view view-icons-test',

	events: {
		'click .icon-test': '_toggleIconMagnification',
		'click .panel-content button.duotone': '_toggleDuotone',
		'click .panel-content button.names': '_toggleNames',
		'input .test-filter-icons': '_filterIcons',
		'change .category-filter': '_filterByCategory'
	},

	render: function () {
		let iconIds = []
		$('symbol').each(function() {
			if (this.id && this.getAttribute('category')) {
				iconIds.push({
					id: this.id.substring(5),
					category: this.getAttribute('category')
				})
			}
		})

		this.$el.html(template())
		_.each(iconIds, item => {
			let iconClass = item.id.includes('-is-unfilled') ? 'icon-test is-unfilled' : 'icon-test'
			this.$('.panel-content .icon-container').append(`
				<div class="view-icon" title="${item.id}" category="${item.category}">
					${icon(item.id, `${iconClass}`)}
					<label>${item.id}</label>
				</div>
			`)
		})

		this._toggleNames()

		// Retrieve the stored filter value and set it as the input value
		let storedFilterValue = localStorage.getItem('filterValue')
		if (storedFilterValue) {
			$('.test-filter-icons').val(storedFilterValue)
			this._filterIcons({ target: $('.test-filter-icons')[0] })
		}

		// Set the stored category filter
		let storedCategoryValue = localStorage.getItem('categoryFilterValue')
		if (storedCategoryValue) {
			$('.category-filter').val(storedCategoryValue)
			this._filterByCategory()
		}

		return this
	},

	_toggleIconMagnification: function (e) {
		this.$(e.target.closest('.view-icon')).toggleClass('is-selected')
	},

	_toggleDuotone: function () {
		this.$('svg').toggleClass('is-duotone')
	},

	_toggleNames: function () {
		this.$('.panel').toggleClass('show-icon-names')
	},

	_filterIcons: function (e) {
		let filterValue = $(e.target).val().toLowerCase()
		localStorage.setItem('filterValue', filterValue)
		this.$('.view-icon').each(function () {
			let title = $(this).attr('title').toLowerCase()
			$(this).toggleClass('is-not-displayed', !title.includes(filterValue))
		})
	},

	_filterByCategory: function () {
		let selectedCategory = $('.category-filter').val().toLowerCase()
		localStorage.setItem('categoryFilterValue', selectedCategory)
		if (selectedCategory === "") {
			this.$('.view-icon').removeClass('is-not-displayed')
		} else {
			this.$('.view-icon').each(function () {
				let category = $(this).attr('category').toLowerCase()
				$(this).toggleClass('is-not-displayed', category !== selectedCategory)
			})
		}
	}
})

export default ViewIconsView